/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>渠道列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入渠道名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="channelName" label="渠道名称">
      </el-table-column>
      <el-table-column prop="appId" label="appId">
      </el-table-column>
      <el-table-column prop="appKey" label="appKey">
      </el-table-column>
      <el-table-column prop="accType" label="接入方式">
        <template slot-scope="scope">
          <div v-if="scope.row.accType ==0">url接入</div>
          <div v-if="scope.row.accType ==1">api接入</div>
          <div v-if="scope.row.accType ==2">基础数据接入</div>
          <div v-if="scope.row.accType ==4">全量接入（自建收银台）</div>
        </template>
      </el-table-column>
      <el-table-column prop="callbackUrl" label="回调地址" width="200">
      </el-table-column>
      <el-table-column prop="state" label="上线状态">
        <template slot-scope="scope">
          <div v-if="scope.row.state ==1">已上线</div>
          <div v-else>未上线</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="400">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit1(scope.$index, scope.row)">修改渠道</el-button>
          <el-button size="mini" @click="handleEdit2(scope.$index, scope.row.channelId,scope.row.channelName)">查看渠道品牌
          </el-button>
          <el-button size="mini" @click="handleEdit3(scope.$index, scope.row.channelId)">查看渠道商家</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="渠道名称" prop="channelName">
          <el-input size="small" v-model="editForm.channelName" auto-complete="off" placeholder="请输入渠道名称"></el-input>
        </el-form-item>
        <el-form-item v-if="title == '添加'" label="渠道登陆密码" prop="channelName">
          <el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="请输入渠道密码"></el-input>
        </el-form-item>

        <el-form-item label="选泽接入方式" prop="roleName">
          <el-select v-model="editForm.accType" placeholder="请选择" size="medium">
            <el-option v-for="item in accTypelist" :key="item.accType" :label="item.accTypename" :value="item.accType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="appId" prop="appId">
          <el-input size="small" v-model="editForm.appId" auto-complete="off" placeholder="请输入appId"></el-input>
        </el-form-item>
        <el-form-item v-if='editForm.accType == 1' label="appSecret" prop="appSecret">
          <el-input size="small" v-model="editForm.appSecret" auto-complete="off" placeholder="请输入appSecret"></el-input>
        </el-form-item>
        <el-form-item v-if='editForm.accType == 1' label="appKey" prop="appKey">
          <el-input size="small" v-model="editForm.appKey" auto-complete="off" placeholder="请输入appKey"></el-input>
        </el-form-item>
        <el-form-item v-if='editForm.accType == 1' label="回调地址" prop="callbackUrl">
          <el-input size="small" v-model="editForm.callbackUrl" auto-complete="off" placeholder="请输入回调地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button v-if="title == '添加'" size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">添加
        </el-button>
        <el-button v-if="title == '修改'" size="small" type="primary" :loading="loading" class="title"
          @click="submitForm1('editForm')">修改
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getChannelList,
    addChannel,
    updateChannel
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          userId: '',
          channelName: '',
          appId: '',
          appSecret: '',
          appKey: '',
          accType: '',
          callbackUrl: '',
          password: '',
        },
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        accTypelist: [{
          accTypename: 'url接入',
          accType: 0
        }, {
          accTypename: 'api接入',
          accType: 1
        }, {
          accTypename: '基础数据接入',
          accType: 2
        }, {
          accTypename: '全量接入（自建收银台）',
          accType: 4
        }, ],
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    created() {
      this.getdata(this.formInline)
    },
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
          "pageSize": parameter.limit,
          "channelName": parameter.varName
        }
        getChannelList(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function(index, row) {
        this.editFormVisible = true
        this.title = '添加'
      },
      handleEdit1: function(index, row) {
        this.editFormVisible = true
        this.title = '修改'
        this.editForm = row
      },
      handleEdit2: function(index, row, row1) {
        const {
          href
        } = this.$router.resolve({
          path: '/goods/brand',
          query: {
            id: row,
            name: row1

          }
        })
        window.open(href, '_blank')
      },
      handleEdit3: function(index, row, row1) {
        const {
          href
        } = this.$router.resolve({
          path: '/goods/goodsmerchant',
          query: {
            id: row,
            name: row1
          }
        })
        window.open(href, '_blank')
      },

      // 编辑、增加页面保存方法
      submitForm(editData) {
        let pro = this.editForm
        pro.h5Url = 'https://h5.maidanyun.com/?shareCode=' + this.editForm.appId
        addChannel(pro)
          .then(res => {
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
              this.getdata(this.formInline)
              this.closeDialog()

            }
          })
      },
      submitForm1(editData) {
        let pro = this.editForm
        pro.h5Url = 'https://h5.maidanyun.com/?shareCode=' + this.editForm.appId
        updateChannel(pro)
          .then(res => {
            if (res.code == 1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '修改成功！'
              })
              this.getdata(this.formInline)
              this.closeDialog()
            }
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
        this.editForm = {
          userId: '',
          channelName: '',
          appId: '',
          appSecret: '',
          appKey: '',
          accType: '',
          callbackUrl: '',
        }
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/Goods.vue